import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase.js';

const defaultConfig = {
  adminEmails: [],
  missionText: '',
  scheduleText: '',
  contactEmail: 'Southietotustuus@gmail.com',
  prayerRequestsSheetUrl: ''
};

const ConfigContext = createContext({ ...defaultConfig, configLoaded: false, refreshConfig: () => {} });

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(defaultConfig);
  const [configLoaded, setConfigLoaded] = useState(false);

  const fetchConfig = useCallback(async () => {
    try {
      const configDoc = await getDoc(doc(db, 'config', 'app'));
      if (configDoc.exists()) {
        setConfig({ ...defaultConfig, ...configDoc.data() });
      }
    } catch (err) {
      console.error('Failed to load app config, using defaults:', err);
    } finally {
      setConfigLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return (
    <ConfigContext.Provider value={{ ...config, configLoaded, refreshConfig: fetchConfig }}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}
